import { ExternalIntegration, WordPressProfile } from 'api/clients/ExternalIntegrationsClient'
import { AvatarWithPlatformIcon } from './AvatarWithPlatformIcon'
import Styles from './ExternalIntegrationSelect.module.scss'
export const ExternalIntegrationItem = ({ externalIntegration }: { externalIntegration: ExternalIntegration }) => {
  return (
    <div className={Styles.item}>
      <AvatarWithPlatformIcon size="sm" avatar={externalIntegration.picture} platform={externalIntegration.provider} />
      <div>{externalIntegration.name || (externalIntegration.additional_data as WordPressProfile)?.url}</div>
    </div>
  )
}
